import { createFileRoute } from "@tanstack/react-router";
import { ApiPage } from "@/components/GoldRateApiPage";
import { STATIC_ALIASES, buildAliasHead } from "@/lib/alias-routes";

const A = STATIC_ALIASES.find((x) => x.slug === "live-gold-rate-api")!;

export const Route = createFileRoute("/live-gold-rate-api")({
  head: () => buildAliasHead({ title: A.title, description: A.description, path: `/${A.slug}` }),
  component: ApiPage,
});